import { render, staticRenderFns } from "./lawQuestion.vue?vue&type=template&id=4b75e32a&"
import script from "./lawQuestion.vue?vue&type=script&lang=js&"
export * from "./lawQuestion.vue?vue&type=script&lang=js&"
import style0 from "./lawQuestion.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports